import { AppointmentResponseKind } from "client/Api/Calendar/calendar";
import * as pubsub from "pubsub-js";

export enum CalendarEvent {
	Responded = "calendar.event.responded",
}

export type RespondId = { appointment: string; } | { master: string; };

export type Data<T extends CalendarEvent> =
	T extends CalendarEvent.Responded ? { id: RespondId; response: AppointmentResponseKind.Accept | AppointmentResponseKind.Decline; } :
	never;

export const subscribe: <T extends CalendarEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends CalendarEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
